module.exports = new __parcel__URL__("antirat_squad_department_level_1.fb33f4d8.png").toString();